import { css } from "@emotion/react";
import { color } from "@/styles/theme";

export const linkStyle = css({
  fontSize: "1.6rem",
  color: color.link,
  ":hover": {
    textDecoration: "underline",
    opacity: 0.7,
    cursor: "pointer",
  },
});

export const footerLinkStyle = css({
  textDecoration: "none",
  color: color.lightBlack,
  ":hover": {
    textDecoration: "underline",
    opacity: 0.7,
    cursor: "pointer",
  },
});
